module.exports = __webpack_public_path__ + "img/gd.c0e77da1.svg";